// Barrel re-export — assembles the unified `api` object from domain gateways
// Backward compat: `import { api } from '../api'` works identically to the old `../utils/api`
import { API_BASE_URL } from './client';
import { companiesApi } from './companies';
import { dealsApi } from './deals';
import { investorsApi } from './investors';
import { relationsApi } from './relations';
import { searchApi } from './search';
import { chatApi } from './chat';
import { authApi } from './auth';
import { statsApi } from './stats';
import { timelineApi } from './timeline';
import { knowledgeApi } from './knowledge';

export const api = {
  ...authApi,
  ...companiesApi,
  ...dealsApi,
  ...investorsApi,
  ...relationsApi,
  ...searchApi,
  ...chatApi,
  ...statsApi,
  ...timelineApi,
  ...knowledgeApi,
};

export { API_BASE_URL };
